export function SubmitOrder(data){
  return window.fetch({
    method:'POST',
    url:'uAppointment/save',
    data:data
  });
}
export function getInfo(data){
  return window.fetch({
    method:'GET',
    url:'uProject/getProjectList',
    data:data
  });
}export function getDetail(data){
  return window.fetch({
    method:'POST',
    url:'uAppointment/getMyAppoint',
    data:data
  });
}
export function getRegister(data){
  return window.fetch({
    method:'POST',
    url:'uReport/getMyReport',
    data:data
  });
}
//获取验证码接口
export function getCode(data){
  return window.fetch({
    method:'POST',
    url:'uReport/sendSmsCode',
    data:data
  });
}
// 查看报告接口
export function showReport(filename){
  return window.fetch({
    method:'GET',
    url:'http://newcrown.natapp1.cc/upload/show/'+filename,
  });
}
export function downReport(data){
  return window.fetch({
    method:'GET',
    url:'http://newcrown.natapp1.cc/upload/show/'+data.filename,
  });
}
// export function getOpenid(data){
//   return window.fetch({
//     method:'POST',
//     url:'/uAppointment/getMyAppointByOpenId',
//     data:data
//   });
// }
// export function getAuthorization(){
//   return window.fetch({
//     method:'get',
//     // url:'/auth/wx?returnUrl=http://newcrown.3gbio.com.cn/',
//     url:'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1ebf423854bfa53f&redirect_uri=http%3A%2F%2Fnewcrown.3gbio.com.cn%2Fnewcrown%2Fauth%2Fwx%2Fcallback&response_type=code&scope=snsapi_base&state=http%3A%2F%2Fnewcrown.3gbio.com.cn%2F&connect_redirect=1#wechat_redirect'
//
//   });
// }
// export function getAuth(data){
//   return window.fetch({
//     method:'get',
//     url:'/auth/wx?returnUrl=http://newcrown.3gbio.com.cn/#/judgement',
//     data:data
//   });
// }
